import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Prompt } from 'react-router-dom';
import classnames from 'classnames';
import HeaderLogo from 'components/HeaderLogo';

import styles from './OnboardingLayout.module.scss';

export default function OnboardingLayout({ children, classes, promptEnabled }) {
  useEffect(() => {
    window.onbeforeunload = promptEnabled ? () => true : null;
    return () => {
      window.onbeforeunload = null;
    };
  }, [promptEnabled]);

  return (
    <>
      <Prompt
        message="Your progress will be lost if you leave this page."
        when={promptEnabled}
      />
      <div className={classnames(styles.page, classes.pageContainer)}>
        <div className={styles.logoWrap}>
          <HeaderLogo />
        </div>
        <div className={classnames(styles.content, classes.pageContent)}>
          {children}
        </div>
      </div>
    </>
  );
}

OnboardingLayout.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.shape({
    pageContainer: PropTypes.string,
    pageContent: PropTypes.string,
  }),
  promptEnabled: PropTypes.bool,
};

OnboardingLayout.defaultProps = {
  children: null,
  classes: {
    pageContainer: '',
    pageContent: '',
  },
  promptEnabled: true,
};
